import {
  Grid,
  TextField,
  InputAdornment,
  Typography,
  Divider,
  Grow,
  Paper,
  MenuList,
  MenuItem,
  Popper,
  ClickAwayListener,
  Popover,
  Button,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import SearchIcon from '@mui/icons-material/Search';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ClearIcon from '@mui/icons-material/Clear';
import AutoCompleteSelect from './AutoComplete/AutoCompleteSelect';
import { MODEL_CATEGORIES, MODEL_LIST } from '../constants';
import clientUtils from '../Utils/clientUtils';
import { ModelTypes } from '../models/APIModels';
import { useSelector } from 'react-redux';
import { CreatSearchForm, SearchSelector, UpdateSearchForm } from '../store/slices/search';
import { useAppDispatch } from '../store';
import { cloneDeep } from 'lodash';

const searchTypes = [
  { name: 'AI Search', id: 'ai' },
  { name: 'Keyword', id: 'keyword' },
];

const sortOptions = [
  { name: 'Relevance', id: 'Relevance' },
  { name: 'RatingAsc', id: 'RatingAsc' },
  { name: 'RatingDsc', id: 'RatingDsc' },
  { name: 'PerformanceAsc', id: 'PerformanceAsc' },
  { name: 'PerformanceDsc', id: 'PerformanceDsc' },
];
const DEFAULT_SORT_TYPE_KEYWORD = { name: 'RatingDsc', id: 'RatingDsc' };
const DEFAULT_SORT_TYPE_AI = { name: 'Relevance', id: 'Relevance' };

interface IProps {
  defaultValue?: string;
  searchType?: string;
  onSearch: (value: string) => void;
  onChange?: (value: string) => void;
  hideSearchTypeMenu?: boolean;
  searchInputPlaceHolder?: string;
  size?: string;
  showFilter?: boolean;
  searchContent?: string;
}

const SearchModelInput = ({
  defaultValue = null,
  onSearch,
  onChange,
  searchType = 'ai',
  hideSearchTypeMenu = false,
  searchInputPlaceHolder = 'Search for a model...',
  size = 'medium',
  showFilter = false,
  searchContent = 'models',
}: IProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openSearchMenu = Boolean(anchorEl);
  const [selectedSearchType, setSelectedSearchType] = useState(searchTypes[0]);
  const inputRef = React.useRef(null);
  const [filterAnchorEl, setFilterAnchorEl] = React.useState<null | HTMLElement>(null);
  const openFilterPopover = Boolean(filterAnchorEl);
  const [selectedModelType, setSelectedModelType] = useState('');
  const [selectedcategory, setSelectedCategory] = useState('');
  const [selectedSort, setSelectedSort] = useState(DEFAULT_SORT_TYPE_AI);
  const { searchForm } = useSelector(SearchSelector);
  const dispatch = useAppDispatch();

  const handleClose = (event: Event) => {
    setAnchorEl(null);
  };
  const handleCloseFilterPopover = (event: Event) => {
    setFilterAnchorEl(null);
  };
  const handleToggle = (event) => {
    if (!hideSearchTypeMenu) {
      setAnchorEl(event.currentTarget);
    }
  };
  const openFilterMenu = (event) => {
    // console.log('inputRef', inputRef.current.clientWidth);
    if (!hideSearchTypeMenu) {
      setFilterAnchorEl(event.currentTarget);
    }
  };
  const onSearchTypeChanged = (value) => {
    setSelectedSearchType(value);
    setAnchorEl(null);
    formUpdate('type', value.id);
    setDefaultSort();
  };
  const doSearch = (e) => {
    // console.log('doSearch');
    const input: HTMLElement | null = inputRef.current;
    if (input) {
      const inputInners = input.getElementsByTagName('input');
      if (inputInners && inputInners.length > 0) {
        let val = inputInners[0].value;
        if (val) val = val.trim();
        inputInners[0].value = val;
        if (onSearch) onSearch(val);
      }
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      doSearch(event);
    }
  };
  const onSearchKeyWordChange = (e) => {
    const value = e.target.value;

    if (onChange) {
      onChange(value);
    }
    formUpdate('keyword', value);
  };

  const formUpdate = (key, value) => {
    let form = searchForm;
    form.paginationId = null;
    form[key] = value;
    dispatch(UpdateSearchForm(form));
  };

  const onSearchBlur = (evt) => {
    // console.log('onSearchBlur');
    let searchText = evt.target.value;
    // console.log('onSearchBlur', searchText);
    if (searchText) {
      searchText = searchText.trim();
      evt.target.value = searchText;
    }
    if (onChange) onChange(searchText);
  };

  const modelTypeChanged = (value) => {
    setSelectedModelType(value);
  };
  const categoryChanged = (value) => {
    setSelectedCategory(value);
  };
  const sortOptionChange = (value) => {
    setSelectedSort(value);
  };

  const applyFilter = (e) => {
    // console.log('applyFilter');

    if (selectedcategory && !clientUtils.isEmpty(selectedcategory.name)) {
      formUpdate('category', selectedcategory.name);
    }
    if (selectedModelType && !clientUtils.isEmpty(selectedModelType.id)) {
      formUpdate('modelType', selectedModelType.id);
    }
    if (selectedSort) {
      formUpdate('sort', selectedSort.id);
    }
    // doSearch(e);
    if (onSearch) onSearch(searchForm.keyword);
  };
  const resetFilter = () => {
    const form = searchForm;
    form.category = null;
    form.modelType = null;
    form.sort = DEFAULT_SORT_TYPE_AI.name;
    form.type = 'ai';
    form.keyword = '';
    form.paginationId = null;
    dispatch(UpdateSearchForm(form));
    if (onSearch) onSearch(form.keyword);
  };
  const setDefaultSort = () => {
    let form = searchForm;
    const type = form.type;
    if (type === 'ai') {
      form.sort = DEFAULT_SORT_TYPE_AI.name;
      setSelectedSort(DEFAULT_SORT_TYPE_AI);
    } else if (type === 'keyword') {
      setSelectedSort(DEFAULT_SORT_TYPE_KEYWORD);
      form.sort = DEFAULT_SORT_TYPE_KEYWORD.name;
    }
    // formUpdate('sort', form.sort);
    dispatch(UpdateSearchForm(form));
  };

  useEffect(() => {
    // console.log('defaultValue changed', { defaultValue, searchType });
    const input: HTMLElement | null = inputRef.current;
    if (input) {
      const inputInners = input.getElementsByTagName('input');
      if (inputInners && inputInners.length > 0) {
        inputInners[0].value = defaultValue;
      }
    }
  }, ['defaultValue']);

  useEffect(() => {}, [selectedSearchType]);
  useEffect(() => {
    const type = searchForm.type;
    if (searchContent === 'mymodels') {
      setSelectedSearchType(type === 'ai' ? searchTypes[0] : searchTypes[1]);
    } else {
      setSelectedSearchType(searchTypes[1]);
    }

    // console.log('search input');
    const category = MODEL_CATEGORIES.find((c) => c.name === searchForm.category);
    if (category) {
      setSelectedCategory(category);
    }
    const modelType = MODEL_LIST.find((m) => m.id === searchForm.modelType);
    if (modelType) {
      setSelectedModelType(modelType);
    }
    const sort = sortOptions.find((s) => s.id === searchForm.sort);
    if (sort) {
      setSelectedSort(sort);
    }
    if (!sort) {
      setDefaultSort();
    }
  }, []);

  return (
    <>
      <Grid item container sx={{ marginBottom: '10px' }}>
        <Grid item xs={12}>
          <TextField
            required
            variant="outlined"
            label=""
            fullWidth
            // size='small'
            placeholder={
              selectedSearchType.id === 'ai'
                ? 'How can I help you? ex. Show me all video generation services'
                : searchInputPlaceHolder
            }
            ref={inputRef}
            sx={{
              input: {
                paddingTop: '20px !important',
              },
            }}
            InputProps={{
              className: 'search-input',
              startAdornment: (
                <InputAdornment position="start" sx={{ marginTop: 0 }}>
                  <Button
                    onClick={(e) => handleToggle(e)}
                    sx={{
                      background: 'none',
                      textTransform: 'none',
                      color: 'rgba(210, 210, 210, 1)',
                      textAlign: 'left',
                      padding: '13px 0px 10px 10px',
                      marginTop: '1px',
                    }}
                    variant="text"
                    // disabled={hideSearchTypeMenu}
                  >
                    <Typography sx={{ width: '60px', fontSize: '13px !important', paddingRight: 3 }}>
                      {selectedSearchType.name}
                    </Typography>{' '}
                    {!hideSearchTypeMenu && (
                      <div style={{ marginTop: '-2px', }}>
                        <ArrowDropDownIcon color="primary" fontSize="medium" />
                      </div>
                    )}
                  </Button>
                  <Divider
                    color="#ddd"
                    orientation="vertical"
                    variant="middle"
                    sx={{ height: 35, width: '3px', marginRight: 1 }}
                  />
                  {showFilter && (
                    <div style={{ marginTop: '2px' }}>
                      <SearchIcon sx={{ cursor: 'pointer' }} color="primary" fontSize="large" />
                    </div>
                  )}
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end" sx={{ marginTop: '2px', fontSize: '21px', marginRight: '8px' }}>
                  {showFilter && (
                    <>
                      <FilterAltIcon sx={{ cursor: 'pointer' }} color="primary" onClick={(e) => openFilterMenu(e)} />
                      <Divider
                        color="#ddd"
                        orientation="vertical"
                        variant="middle"
                        sx={{ height: 35, width: '3px', marginRight: 1, marginLeft: 1 }}
                      />

                      <ClearIcon sx={{ cursor: 'pointer' }} onClick={resetFilter} />
                    </>
                  )}
                  {!showFilter && (
                    <SearchIcon sx={{ cursor: 'pointer' }} color="primary" fontSize="large" onClick={(e) => doSearch(e)} />
                  )}
                </InputAdornment>
              ),
              onBlur: onSearchBlur,
              autoComplete: 'off',
            }}
            onChange={onSearchKeyWordChange}
            value={defaultValue ?? ''}
            onKeyDown={handleKeyDown}
          />
          {
            <Popper
              style={{
                zIndex: 1,
              }}
              open={openSearchMenu}
              anchorEl={anchorEl}
              role={undefined}
              transition
              placement="bottom-start"
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                    marginTop: '4px',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={(e) => handleClose(e)}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        {searchTypes.map((option, index) => (
                          <MenuItem
                            key={option.id}
                            // disabled={index === 2}
                            selected={option.id === selectedSearchType.id}
                            onClick={(event) => onSearchTypeChanged(option)}
                          >
                            {option.name}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          }
          {
            <Popover
              open={Boolean(filterAnchorEl)}
              anchorEl={filterAnchorEl}
              onClose={handleCloseFilterPopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{ marginTop: '14px' }}
            >
              <Grid container spacing={3} padding={2} width={'270px'}>
                <Grid item xs={12}>
                  <h5 style={{ fontWeight: 700 }}>Refine Results</h5>
                  <Divider />
                </Grid>

                <Grid item xs={12}>
                  <AutoCompleteSelect
                    id="model-type-select"
                    items={MODEL_LIST}
                    itemText="displayNameInSearch"
                    itemKey="id"
                    labelText="Model Type"
                    placeHolderText="Select Model"
                    multiSelect={false}
                    labelPaddingTop="-5px"
                    defaultValue={selectedModelType}
                    onChange={modelTypeChanged}
                    allowEmptyValue={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoCompleteSelect
                    id="category-select"
                    items={MODEL_CATEGORIES}
                    itemText="name"
                    itemKey="id"
                    labelText="Category"
                    placeHolderText="Select Category"
                    multiSelect={false}
                    labelPaddingTop="-5px"
                    defaultValue={selectedcategory}
                    onChange={categoryChanged}
                    allowEmptyValue={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoCompleteSelect
                    id="sort-sort"
                    items={sortOptions}
                    itemText="name"
                    itemKey="id"
                    labelText="Sort"
                    placeHolderText="Sort By"
                    multiSelect={false}
                    labelPaddingTop="-5px"
                    defaultValue={selectedSort}
                    onChange={sortOptionChange}
                    allowEmptyValue={true}
                  />
                </Grid>

                <Grid item xs={5} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                  <hr />

                  <Button
                    type="button"
                    onClick={(e) => handleCloseFilterPopover(e)}
                    variant="text"
                    color="info"
                    sx={{ fontWeight: 700, fontSize: '1rem', paddingLeft: '25px' }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={1}>
                  <Divider
                    color="#ddd"
                    orientation="vertical"
                    variant="middle"
                    sx={{ height: 35, width: '3px', marginRight: 1, marginLeft: 1 }}
                  />
                </Grid>
                <Grid item xs={5} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                  <Button
                    type="button"
                    onClick={(e) => applyFilter(e)}
                    variant="text"
                    size="small"
                    color="info"
                    sx={{ fontWeight: 600, fontSize: '1rem' }}
                  >
                    Apply
                  </Button>
                </Grid>
              </Grid>
            </Popover>
          }
        </Grid>
      </Grid>
    </>
  );
};

export default SearchModelInput;
